import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";

import Email from "./Email";
import Facebook from "./Facebook";
import { FIELDS } from "apps/signup/util/constants";

import "./index.scss";

if (process.env.PLATFORM === "desktop") {
	require("./index.desktop.scss");
} else {
	require("./index.mobile.scss");
}

const EmailOrFB = (props) => {
	return (
		<div className="signup2017-emailOrFacebook signup2017-field-wrapper">
			<Facebook
				hasError={props.errors.facebook}
				feedback={props.feedback.facebook}
				facebookState={props.facebookState}
				facebookSignup={props.facebookSignup}
				success={props.success.email}
			/>

			<div className="signup2017-emailOrFacebook-divider">
				<span className="signup2017-emailOrFacebook-line" />
				<Str className="signup2017-emailOrFacebook-text">or</Str>
			</div>

			<Email
				value={props.email}
				dismissSuggestion={props.dismissSuggestion}
				hasError={props.errors.email}
				success={props.success.email}
				suggestion={props.suggestions.email}
				feedback={props.feedback.email}
				onChange={props.onChange}
				validate={props.validate}
				fieldName={FIELDS.EMAIL}
				isUpdating={props.isUpdating}
			/>
		</div>
	);
};

EmailOrFB.propTypes = {
	email: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	validate: PropTypes.func.isRequired,
	dismissSuggestion: PropTypes.func.isRequired,
	facebookSignup: PropTypes.func.isRequired,
	facebookState: PropTypes.string.isRequired,
	isUpdating: PropTypes.bool,
	errors: PropTypes.object,
	feedback: PropTypes.object,
	suggestions: PropTypes.object,
	success: PropTypes.object,
};

EmailOrFB.defaultProps = {
	isUpdating: false,
	errors: {},
	success: {},
	feedback: {},
	suggestions: {},
};

export default EmailOrFB;



// WEBPACK FOOTER //
// ./src/apps/signup/components/EmailOrFb/index.jsx